import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./login.css";
import CoverPhoto from "../../../Assets/Images/login_img1.png";
import NavbarCustom from "../../../Components/NavbarCustom";
import { useLogin } from "../../../APIContext/LoginContext";
import Swal from "sweetalert2";
import SEO from "../../../Components/SEO";

const Login = () => {
  const { login, error, loading } = useLogin();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [formError, setFormError] = useState("");
  const navigate = useNavigate();

  const validateForm = () => {
    if (!identifier.trim()) {
      setFormError("Please enter email or username.");
      return false;
    }

    if (!password.trim()) {
      setFormError("Please enter your password.");
      return false;
    }

    setFormError("");
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      Swal.fire({
        icon: "warning",
        title: "Validation Error",
        text: formError,
        confirmButtonColor: "#B79527", // orange / gold
        cancelButtonColor: "#1C1C1C",
      });
      return;
    }

    const payload = {
      username_or_email: identifier,
      password,
    };

    const result = await login(payload);

    // if (result?.success) {
    //   Swal.fire({
    //     icon: "success",
    //     title: "Login Successful",
    //     text: "Welcome back!",
    //     timer: 1500,
    //     showConfirmButton: false,
    //   })
    // } else {
    //   Swal.fire({
    //     icon: "error",
    //     title: "Login Failed",
    //     text: error || "Invalid credentials or server error",
    //   });
    // }
  };

  // Navigate to home if user already logged in
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      navigate("/");
    }
  }, []);

  return (
    <>
      <SEO
        title="BWC Sports | Login"
        description=""
        url="https://bwcsports.com/login"
      />
      <NavbarCustom />
      <div className="login-container">
        <div className="cover-photo-banner-con">
          <div className="cover-photo-banner-login">
            <img src={CoverPhoto} alt="Cover" className="cover-photo" />
          </div>
        </div>

        <div className="login-form-con">
          <div className="login-form">
            <h2>Login</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  id="identifier"
                  name="identifier"
                  placeholder="Email ID or Username"
                  value={identifier}
                  onChange={(e) => setIdentifier(e.target.value)}
                />
              </div>
              <div className="form-group">
                <input
                  type="password"
                  id="password"
                  name="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              {formError && <p className="error-message">{formError}</p>}

              <div className="form-group">
                <a href="/send-otp" className="forgot-password">
                  Forgot Password?
                </a>
              </div>

              <button
                type="submit"
                className="sign-in-button"
                disabled={loading}
              >
                {loading ? "Signing In..." : "Sign In"}
              </button>

              {error && !formError && <p className="error-message">{error}</p>}
            </form>

            <hr />
            <div className="new-account">
              <p className="black-text-clip">New here? Create an Account!</p>
              <Link className="create-account-button" to="/create-an-account">
                Create Your Account
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
